import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useUserProfiles } from "context/UserProfileContext";
import { pageOrMovedToV2 } from "components/shared-components/MovedToV2Notice";

export const AppViews = () => {
  const { userPerms } = useUserProfiles();

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${APP_PREFIX_PATH}/home`}
          component={lazy(() => import(`./home`))}
        />
        {userPerms.includes('upload-banner') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/upload-banner`}
            component={lazy(() => import(`./operation/upload-banner`))}
          />
        }
        {userPerms.includes('modify-home-buttons') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/modify-home-buttons`}
            component={lazy(() => import(`./operation/modify-home-buttons`))}
          />
        }
        {userPerms.includes('manage-patch') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/manage-patch`}
            component={lazy(() => import(`./operation/manage-patch`))}
          />
        }
        {userPerms.includes('schedule-downtime') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/schedule-downtime`}
            component={lazy(() => import(`./operation/schedule-downtime`))}
          />
        }
        {userPerms.includes('clone-accounts') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/clone-accounts`}
            component={pageOrMovedToV2("clone-accounts", lazy(() => import(`./operation/clone-accounts`)))}
          />
        }
        {userPerms.includes('manage-surveys') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/manage-surveys`}
            component={lazy(() => import(`./operation/manage-surveys`))}
          />
        }
        {userPerms.includes('cash-store') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/cash-store`}
            component={lazy(() => import(`./operation/cash-store`))}
          />
        }
        {userPerms.includes('auto-ban') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/auto-ban`}
            component={lazy(() => import(`./operation/auto-ban`))}
          />
        }
        {userPerms.includes('client-files-manager') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/client-files-manager`}
            component={lazy(() => import(`./operation/client-files-manager`))}
          />
        }
        {
          userPerms.includes('loyalty-path') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/loyalty-path`}
            component={lazy(() => import(`./operation/loyalty-path/loyalty-path`))}
          />
        }
        {
          userPerms.includes('drop-list-exceptions') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/drop-list-exceptions`}
            component={lazy(() => import(`./operation/drop-list-exceptions`))}
          />
        }
        {
          userPerms.includes('inventario-virtual') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/inventario-virtual`}
            component={lazy(() => import(`./operation/inventory/inventory`))}
          />
        }
        {userPerms.includes('loki-audit') &&
          <Route
            path={`${APP_PREFIX_PATH}/operation/loki-audit`}
            component={lazy(() => import(`./operation/loki-audit`))}
          />
        }
        {userPerms.includes('find-player') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/find-player`}
            component={lazy(() => import(`./support/find-player`))}
          />
        }
        {userPerms.includes('find-guild') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/find-guild`}
            component={pageOrMovedToV2("find-guild", lazy(() => import(`./support/find-guild`)))}
          />
        }
        {userPerms.includes('send-items') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/send-items`}
            component={lazy(() => import(`./support/send-items`))}
          />
        }
        {userPerms.includes('rank-players') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/rank-players`}
            component={lazy(() => import(`./support/rank-players`))}
          />
        }
        {userPerms.includes('rank-guilds') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/rank-guilds`}
            component={pageOrMovedToV2("rank-guilds", lazy(() => import(`./support/rank-guilds`)))}
          />
        }
        {userPerms.includes('twitch-users') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/twitch-users`}
            component={lazy(() => import(`./support/twitch-users`))}
          />
        }
        {userPerms.includes('ban-players') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/ban-players`}
            component={lazy(() => import(`./support/ban-players`))}
          />
        }
        {userPerms.includes('manage-guilds') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/manage-guilds`}
            component={pageOrMovedToV2("manage-guilds", lazy(() => import(`./support/manage-guilds`)))}
          />
        }
        {userPerms.includes('gm-tools') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/gm-tools`}
            component={lazy(() => import(`./support/gm-tools`))}
          />
        }
        {userPerms.includes('gold-count') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/gold-count`}
            component={lazy(() => import(`./support/gold-count`))}
          />
        }
        {userPerms.includes('global-bot') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/global-bot`}
            component={lazy(() => import(`./support/global-bot`))}
          />
        }
        {userPerms.includes('global-bot-tool') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/global-bot-tool`}
            component={lazy(() => import(`./support/global-bot-tool`))}
          />
        }
        {userPerms.includes('editor-info-json') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/editor-info-json`}
            component={lazy(() => import(`./support/editor-info-json`))}
          />
        }
        {userPerms.includes('accounts-np') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/accounts-np`}
            component={lazy(() => import(`./support/accounts-np`))}
          />
        }
        {userPerms.includes('related-accounts') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/related-accounts`}
            component={lazy(() => import(`./support/related-accounts`))}
          />
        }
        {userPerms.includes('punishment-list') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/punishment-list`}
            component={lazy(() => import(`./support/punishment-list`))}
          />
        }
        {userPerms.includes('all-emails') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/all-emails`}
            component={lazy(() => import(`./support/all-emails/all-emails`))}
          />
        }
        {userPerms.includes('action-logs') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/action-logs`}
            component={lazy(() => import(`./support/action-logs`))}
          />
        }
        {userPerms.includes('log-analyzer') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/log-analyzer`}
            component={lazy(() => import(`./support/log-analyzer`))}
          />
        }
        {userPerms.includes('item-tracking') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/item-tracking`}
            component={pageOrMovedToV2("item-tracking", lazy(() => import(`./support/item-tracking`)))}
          />
        }
        {userPerms.includes('purchase-management') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/purchase-management`}
            component={lazy(() => import(`./support/purchase-management`))}
          />
        }
        {userPerms.includes('send-custom-email') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/send-custom-email`}
            component={lazy(() => import(`./support/send-custom-email`))}
          />
        }
        {userPerms.includes('incidents-tickets') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/incidents-tickets`}
            component={pageOrMovedToV2("incidents-tickets", lazy(() => import(`./support/incidents-tickets`)))}
          />
        }
        {userPerms.includes('search-key-items') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/search-key-items`}
            component={lazy(() => import(`./support/search-key-items`))}
          />
        }
        {userPerms.includes('costume-identifier') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/costume-identifier`}
            component={lazy(() => import(`./support/costume-identifier`))}
          />
        }
        {userPerms.includes('game-metrics') &&
          <Route
            path={`${APP_PREFIX_PATH}/support/game-metrics`}
            component={lazy(() => import(`./support/game-metrics`))}
          />
        }
        {userPerms.includes('ccu') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/ccu`}
            component={lazy(() => import(`./analytics/ccu`))}
          />
        }
        {userPerms.includes('revenue') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/revenue`}
            component={lazy(() => import(`./analytics/revenue`))}
          />
        }
        {userPerms.includes('new-players-revenue') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/new-players-revenue`}
            component={lazy(() => import(`./analytics/new-players-revenue`))}
          />
        }
        {userPerms.includes('performance') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/performance`}
            component={lazy(() => import(`./analytics/performance`))}
          />
        }
        {userPerms.includes('gateway-info') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/gateway-info`}
            component={lazy(() => import(`./analytics/gateway-info`))}
          />
        }
        {userPerms.includes('crm') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/crm`}
            component={lazy(() => import(`./analytics/crm`))}
          />
        }
        {userPerms.includes('item-amount') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/item-amount`}
            component={lazy(() => import(`./analytics/item-amount`))}
          />
        }
        {userPerms.includes('urlshorter-metrics') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/urlshorter-metrics`}
            component={lazy(() => import(`./analytics/urlshorter-metrics`))}
          />
        }
        {userPerms.includes('royalarena-reports') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/royalarena-reports`}
            component={lazy(() => import(`./analytics/royalarena-reports`))}
          />
        }
        {userPerms.includes('generate-player-purchase-report') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/generate-player-purchase-report`}
            component={lazy(() => import(`./analytics/generate-player-purchase-report`))}
          />
        }
        {userPerms.includes('activeplayers-per-country') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/activeplayers-per-country`}
            component={lazy(() => import(`./analytics/activeplayers-per-country`))}
          />
        }
        {/* comment: Página desativada temporariamente */}
        {/* userPerms.includes('sunset-followup') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/sunset-followup`}
            component={lazy(() => import(`./analytics/sunset-followup`))}
          />
        */}
        {userPerms.includes('graylist') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/graylist`}
            component={lazy(() => import(`./analytics/graylist/index`))}
          />
        }
        {userPerms.includes('campaign-cost') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/campaign-cost`}
            component={lazy(() => import(`./analytics/campaign-cost`))}
          />
        }
        {userPerms.includes('personas') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/personas`}
            component={lazy(() => import(`./analytics/personas`))}
          />
        }
        {userPerms.includes('items') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/items`}
            component={lazy(() => import(`./analytics/items`))}
          />
        }
        {userPerms.includes('reports') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/reports`}
            component={lazy(() => import(`./analytics/reports`))}
          />
        }
        {userPerms.includes('revenue-goals') &&
          <Route
            path={`${APP_PREFIX_PATH}/analytics/revenue-goals`}
            component={lazy(() => import(`./analytics/revenue-goals`))}
          />
        }
        {userPerms.includes('manage-rds') &&
          <Route
            path={`${APP_PREFIX_PATH}/developer/manage-rds`}
            component={lazy(() => import(`./developer/manage-rds`))}
          />
        }
        {userPerms.includes('manage-users') &&
          <Route
            path={`${APP_PREFIX_PATH}/developer/manage-users`}
            component={pageOrMovedToV2("manage-users", lazy(() => import(`./developer/manage-users`)))}
          />
        }

        {/* Todos redirecionando para a Home */}
        {/* <Redirect
          from={`${APP_PREFIX_PATH}/operation`}
          to={`${APP_PREFIX_PATH}/operation/upload-banner`}
        />
        <Redirect
          from={`${APP_PREFIX_PATH}/support`}
          to={`${APP_PREFIX_PATH}/support/find-player`}
        />
        <Redirect
          from={`${APP_PREFIX_PATH}/analytics`}
          to={`${APP_PREFIX_PATH}/analytics/crm`}
        /> */}

        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
